// extracted by mini-css-extract-plugin
module.exports = {"gridItemText":"VideoGroup_gridItemText__MIEeN","textContainer":"VideoGroup_textContainer__4fgDt"};